export default __webpack_public_path__ + "b6f312c13b8dee38eb717c2cea679c5e.png";